import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import { BASE_URL } from "../data/baseURL";

const Newsletter = () => {
  const { register, handleSubmit } = useForm();
  const [userInfo, setUserInfo] = useState({
    ip: "",
    country: "",
    countryCode: "",
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    window
      .fetch("https://geolocation-db.com/json/")
      .then((res) => res.json())
      .then((data) => {
        setUserInfo({
          ip: data.IPv4,
          country: data.country_name,
          countryCode: data.country_code,
          latitude: data.latitude,
          longitude: data.longitude,
        });
      });
  }, []);

  const handleNewsLetter = (data, e) => {
    const newsLetterInfo = {
      ...userInfo,
      email: data.email,
    };

    fetch(`${BASE_URL}/news-letter`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(newsLetterInfo),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          e.target.reset();
          swal("Thank You!", "For Subscribing!", "success");
        }
      });
  };

  return (
    <section className="container-fluid bg-ghost-white">
      <div className="ms-13 me-13 pt-11 pb-13">
        <h1 className="fs-56 gilroy-bold text-center pt-5">
          Stay Up To Date With Our Newsletter
        </h1>

        <form
          className="d-flex justify-content-center mt-7"
          onSubmit={handleSubmit(handleNewsLetter)}
        >
          <input
            type="email"
            required
            placeholder="Email address"
            className="fs-16 border-0 w-full py-4 news-letter-input"
            {...register("email", { required: true })}
          />

          <button
            type="submit"
            className="text-uppercase fs-20 fs-700 bg-american-yellow news-letter-btn text-white"
          >
            subscribe
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
